/* Burger menu toogle */

import { valueResponsiveMenu, witdhWindow, isMobile } from './utilities'

const menuMobile = document.querySelector('.site-header-navigation'),
    navMobile = document.querySelector('#site-navigation'),
    btnMenuMobile = document.querySelector('#menu-mobile-button'),
    AllItemMenuMobile = document.querySelectorAll('#site-navigation a'), // va chercher les a dans le .sub-nav-mobile
    firstItemMenuMobile = AllItemMenuMobile[0],
    lastItemMenuMobile = AllItemMenuMobile[AllItemMenuMobile.length - 1]

// Au chargement de la page
window.addEventListener('load', function () {
    if (isMobile()) {

        AllItemMenuMobile.forEach(ItemMenuMobile => {

            ItemMenuMobile.setAttribute("tabindex", "-1"); // remove le Tab sur les liens du menu si menu fermé
            if (ItemMenuMobile.parentElement.classList.contains('menu-item-has-children')) {

                let idExpended = ItemMenuMobile.nextSibling.id //
                ItemMenuMobile.setAttribute("aria-controls", idExpended); // 
            }
        });
    }
});

// Au click du bouton burger mobile
btnMenuMobile.addEventListener('click', function () {
    menuOpen(menuMobile, btnMenuMobile);
});

// Touche echap 
document.addEventListener("keydown", (event) => {
    if ((event.key === 'Escape') && (isMobile())) {
        closeMenuMobile();
    }

});

if(lastItemMenuMobile) {
    // Au tab du dernier item du menu mobile on retourne sur le bouton toggle
    lastItemMenuMobile.addEventListener("focusout", (event) => {
        if (isMobile() && menuMobile.classList.contains('open')) {
            btnMenuMobile.focus();
        }
    });
}

// Function Ouverture du menu
function menuOpen(menuMobile, btnMenuMobile) {
    menuMobile.classList.toggle('open');
    btnMenuMobile.classList.toggle('open');
    document.body.classList.toggle('no-scroll');

    // Si le menu est OUVERT
    if (menuMobile.classList.contains('open')) {
        navMobile.setAttribute("aria-expanded", true);
        btnMenuMobile.setAttribute("aria-expanded", true);
        AllItemMenuMobile.forEach(ItemMenuMobile => {
            ItemMenuMobile.setAttribute("tabindex", "0"); // add le Tab sur les liens du menu
        });

        // Si le menu est FERMÉ
    } else {
        navMobile.setAttribute("aria-expanded", false);
        btnMenuMobile.setAttribute("aria-expanded", false);
        AllItemMenuMobile.forEach(ItemMenuMobile => {
            ItemMenuMobile.setAttribute("tabindex", "-1"); // remove le Tab sur les liens du menu
        });
    }

    if(window.innerWidth < 1020) {
        if(document.body.classList.contains('sub-menu-open')) {
            document.body.classList.remove('sub-menu-open');
            document.body.classList.add('sub-menu-close');
        } else {
            document.body.classList.add('sub-menu-open');
            document.body.classList.remove('sub-menu-close');
        }
    }
}

// Fonction Fermeture du menu
function closeMenuMobile() {
    menuMobile.classList.remove('open');
    btnMenuMobile.classList.remove('open');
    document.body.classList.remove('no-scroll');
    document.body.classList.remove('sub-menu-open');
    document.body.classList.add('sub-menu-close');
    navMobile.setAttribute("aria-expanded", false);
    btnMenuMobile.setAttribute("aria-expanded", false);
    AllItemMenuMobile.forEach(ItemMenuMobile => {
        ItemMenuMobile.setAttribute("tabindex", "-1"); // remove le Tab sur les liens du menu
    });

}